import * as types from './types';

export const apiSearchQueryRequest = (queryText) => ({
  type: types.SEARCH_QUERY.REQUEST,
  payload: {
    queryText,
  },
});

export const setSearchQueryText = (queryText) => ({
  type: types.SET_SEARCH_QUERY_TEXT,
  payload: {
    queryText,
  },
});


// WEBPACK FOOTER //
// ./src/actions/search/actions.js